<template>
	<div class="national-map-page">
		<div class="map-wrap flexCol alit justc">
			<center-map style="width: 100vw;height: 100vh;position: absolute;z-index: 2;margin-top:0%;" :scanal="110"
				:business-points="currentBusinessPoints" :selected-point-id="selectedPointId"
				@business-point-click="selectPoint"></center-map>
		</div>

		<div class="left-menu">
			<div class="left-menu-item" v-for="(item, index) in menuList" :key="item.name"
				:class="{ active: index === activeMenu }" @click="activeMenu = index">
				<span class="menu-icon" :class="item.icon"></span>
				<span>{{ item.name }}</span>
				<i></i>
			</div>
		</div>

		<div class="right-panels flexCol">
			<div class="map-panel">
				<div class="title">
					<div>{{ currentInfoTitle }}</div>
				</div>
				<div class="info-style">
					<div class="selected-name">{{ selectedPoint.name }}</div>
					<div class="info-copy">
						<p v-for="item in selectedPoint.info" :key="item.label"><b>{{ item.label }}：</b>{{ item.value }}
						</p>
					</div>
				</div>
			</div>

			<div class="map-panel panel-gap">
				<div class="title">
					<div>基地历史历程</div>
				</div>
				<div class="info-style">
					<div class="timeline-copy">{{ selectedPoint.name }} 从建设到当前的历史历程</div>
					<div class="timeline-wrap" ref="timelineWrap">
						<div class="timeline-board">
							<div class="timeline-row timeline-row-top">
								<div class="timeline-cell" v-for="item in selectedPoint.timeline"
									:key="item.year + '-top'">
									<span v-if="item.position === 'top'">{{ item.label }}</span>
								</div>
							</div>
							<div class="timeline-axis">
								<div class="timeline-line"></div>
								<div class="timeline-year" v-for="item in selectedPoint.timeline" :key="item.year">
									<b>{{ item.year }}</b>
								</div>
							</div>
							<div class="timeline-row timeline-row-bottom">
								<div class="timeline-cell" v-for="item in selectedPoint.timeline"
									:key="item.year + '-bottom'">
									<span v-if="item.position === 'bottom'">{{ item.label }}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="map-panel panel-gap">
				<div class="title">
					<div>趋势预测</div>
				</div>
				<div class="info-style">
					<div class="trend-head">
						<div>{{ selectedPoint.name }}实际与预测走势</div>
						<select v-model="trendMetric">
							<option value="产量">产量</option>
							<option value="销量">销量</option>
							<option value="价格">价格</option>
						</select>
					</div>
					<div class="trend-chart">
						<div class="trend-unit">单位：{{ trendUnit }}</div>
						<div class="grid-line" v-for="item in 5" :key="item"></div>
						<svg viewBox="0 0 320 130" preserveAspectRatio="none">
							<polyline :points="currentTrend.actual" fill="none" stroke="#0aa7ff"
								stroke-width="3" />
							<polyline :points="currentTrend.predict" fill="none" stroke="#9bc74b"
								stroke-width="2" stroke-dasharray="5 4" />
						</svg>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import centerMap from './centerMap.vue'

export default {
	name: 'NationalMap',
	components: {
		centerMap
	},
	computed: {
		currentMenu() {
			return this.menuList[this.activeMenu]
		},
		currentPoints() {
			return this.mapData[this.currentMenu.key] || []
		},
		currentBusinessPoints() {
			return this.currentPoints.map(item => {
				const coordinate = this.pointCoordinates[item.id] || [106.55, 29.56]
				return {
					...item,
					longitude: coordinate[0],
					latitude: coordinate[1]
				}
			})
		},
		selectedPoint() {
			return this.currentPoints.find(item => item.id === this.selectedPointId) || this.currentPoints[0]
		},
		currentInfoTitle() {
			return this.currentMenu.panelTitle
		},
		trendUnit() {
			const map = { '产量': '吨', '销量': '件', '价格': '万元' }
			return map[this.trendMetric]
		},
		currentTrend() {
			return this.selectedPoint.trend[this.trendMetric] || this.selectedPoint.trend['产量']
		}
	},
	watch: {
		activeMenu() {
			this.selectedPointId = this.currentPoints[0] ? this.currentPoints[0].id : ''
			this.resetTimelineScroll()
		},
		selectedPointId() {
			this.resetTimelineScroll()
		}
	},
	mounted() {
		this.resetTimelineScroll()
	},
	data() {
		return {
			activeMenu: 0,
			selectedPointId: 'food-jiangjin',
			trendMetric: '产量',
			menuList: [{ name: '食材产地', icon: 'user', key: 'food', panelTitle: '基地信息' }, { name: '生产加工', icon: 'user', key: 'processing', panelTitle: '加工企业信息' }, { name: '现代服务', icon: 'user', key: 'service', panelTitle: '服务网点信息' }, { name: '供需市场', icon: 'user', key: 'market', panelTitle: '门店信息' }, { name: '交易 & 流通', icon: 'mail', key: 'trade', panelTitle: '交易流通信息' }, { name: '食安 & 溯源', icon: 'user', key: 'trace', panelTitle: '溯源节点信息' }, { name: '人才就业', icon: 'user', key: 'talent', panelTitle: '人才服务信息' }, { name: '产业运行统计', icon: 'user', key: 'operation', panelTitle: '运行统计信息' }],
			pointCoordinates: {
				'food-jiangjin': [106.26, 29.29],
				'food-tongnan': [105.84, 30.19],
				'food-shizhu': [108.11, 30.0],
				'processing-yubei': [106.63, 29.72],
				'processing-fuling': [107.39, 29.7],
				'service-nanan': [106.56, 29.52],
				'market-jiefangbei': [106.58, 29.56],
				'trade-supply': [106.49, 29.48],
				'trace-food': [106.55, 29.57],
				'talent-center': [106.5, 29.61],
				'operation-index': [106.55, 29.56]
			},
			mapData: {
				food: [{ id: 'food-jiangjin', name: '江津花椒基地', x: 51, y: 55, suggestion: '产量进入稳步增长阶段，建议扩大订单农业合作范围。', trend: this.mkTrend([118,100,82,44,58,52,40], [112,96,78,56,50,46,38], [108,92,70,52,56,48,42]), info: [{ label: '基地名称', value: '江津花椒基地' }, { label: '占地面积', value: '3200亩' }, { label: '年产量', value: '8600吨' }, { label: '合作采购商', value: '26家' }, { label: '质检等级', value: 'A级' }, { label: '溯源状态', value: '已接入' }], timeline: this.createTimeline(['基地选址', '土地整理', '种苗引入', '标准化种植', '溯源接入', '产能扩建', '品牌出海'], 2018) }, { id: 'food-tongnan', name: '潼南蔬菜基地', x: 48, y: 49, suggestion: '近期供应波动偏高，建议加强采收周期监测。', trend: this.mkTrend([106,92,74,86,72,66,61], [100,86,70,80,68,62,58], [104,90,76,72,64,58,54]), info: [{ label: '基地名称', value: '潼南蔬菜基地' }, { label: '占地面积', value: '5100亩' }, { label: '年产量', value: '1.2万吨' }, { label: '合作采购商', value: '18家' }, { label: '质检等级', value: 'B级' }, { label: '溯源状态', value: '部分接入' }], timeline: this.createTimeline(['基地规划', '土地流转', '设施建设', '冷链配套', '采购扩容', '质量升级', '订单扩展'], 2019) }, { id: 'food-shizhu', name: '石柱辣椒基地', x: 55, y: 46, suggestion: '需求侧增长明显，建议提前锁定核心门店采购。', trend: this.mkTrend([122,104,78,52,46,38,34], [116,98,72,48,44,36,30], [110,94,82,56,50,44,38]), info: [{ label: '基地名称', value: '石柱辣椒基地' }, { label: '占地面积', value: '4600亩' }, { label: '年产量', value: '9700吨' }, { label: '合作采购商', value: '31家' }, { label: '质检等级', value: 'A级' }, { label: '溯源状态', value: '已接入' }], timeline: this.createTimeline(['基地建设', '品种选育', '品牌认证', '订单增长', '示范创建', '产业联动', '持续扩产'], 2017) }],
				processing: [{ id: 'processing-yubei', name: '渝北底料工厂', x: 54, y: 51, suggestion: '产能利用率较高，建议增加旺季备货。', trend: this.mkTrend([105,80,65,48,42,45,36], [100,76,60,44,40,42,34], [108,88,72,52,48,50,40]), info: [{ label: '企业名称', value: '渝北底料工厂' }, { label: '规模', value: '中型' }, { label: '月产能', value: '1800吨' }, { label: '产品品类', value: '牛油底料、清油底料' }, { label: '资质认证', value: 'SC / ISO22000' }, { label: '合规状态', value: '正常' }], timeline: this.createTimeline(['厂房投建', '设备调试', '产线投产', '资质认证', '产能扩建', '智能化升级', '满产运营'], 2018) }, { id: 'processing-fuling', name: '涪陵调味品加工厂', x: 57, y: 52, suggestion: '原料供应稳定，可承接更多连锁品牌订单。', trend: this.mkTrend([116,94,88,60,52,48,45], [110,88,82,56,48,44,42], [106,92,80,58,54,50,46]), info: [{ label: '企业名称', value: '涪陵调味品加工厂' }, { label: '规模', value: '大型' }, { label: '月产能', value: '2600吨' }, { label: '产品品类', value: '蘸料、复合调味料' }, { label: '资质认证', value: 'SC / HACCP' }, { label: '合规状态', value: '正常' }], timeline: this.createTimeline(['主体建成', '设备进场', '试生产', '规模生产', '品类拓展', '渠道拓展', '规模扩张'], 2016) }],
				service: [{ id: 'service-nanan', name: '南岸检测服务站', x: 52, y: 53, suggestion: '检测响应稳定，建议覆盖周边区县。', trend: this.mkTrend([98,84,70,62,55,53,48], [94,80,66,58,52,50,44], [100,88,74,66,60,56,50]), info: [{ label: '网点地址', value: '重庆南岸区' }, { label: '服务范围', value: '食品检测、企业培训' }, { label: '检测能力', value: '320批次/月' }, { label: '培训人次', value: '1200人次' }], timeline: this.createTimeline(['网点设立', '人员配备', '检测接入', '培训开班', '服务扩面', '区县覆盖', '智能升级'], 2019) }],
				market: [{ id: 'market-jiefangbei', name: '解放碑示范门店', x: 53, y: 50, suggestion: '客流持续恢复，建议加强晚市套餐投放。', trend: this.mkTrend([118,90,75,58,50,48,42], [112,84,70,54,46,44,38], [108,94,80,62,56,52,46]), info: [{ label: '门店地址', value: '渝中区解放碑' }, { label: '开业时间', value: '2019-08' }, { label: '经营状态', value: '营业中' }, { label: '星级等级', value: '五星' }, { label: '日均营收', value: '8.6万元' }], timeline: this.createTimeline(['门店开业', '品牌升级', '数字接入', '营收增长', '口碑沉淀', '连锁扩张', '持续盈利'], 2019) }],
				trade: [{ id: 'trade-supply', name: '西部食材集配中心', x: 50, y: 58, suggestion: '交易订单稳定增长，建议优化干线配送频次。', trend: this.mkTrend([110,92,62,50,46,38,35], [104,86,58,46,42,36,32], [106,94,76,58,52,46,40]), info: [{ label: '节点名称', value: '西部食材集配中心' }, { label: '交易规模', value: '日均 420 单' }, { label: '流通范围', value: '川渝、华中' }, { label: '履约状态', value: '正常' }], timeline: this.createTimeline(['仓网建设', '交易上线', '线路扩容', '履约提升', '智能分拨', '区域联动', '规模倍增'], 2020) }],
				trace: [{ id: 'trace-food', name: '火锅食安溯源节点', x: 56, y: 57, suggestion: '溯源覆盖率提升，建议补齐小微供应商数据。', trend: this.mkTrend([120,96,66,44,40,36,31], [114,90,60,40,36,32,28], [108,94,80,56,50,44,38]), info: [{ label: '节点名称', value: '火锅食安溯源节点' }, { label: '覆盖批次', value: '15万+' }, { label: '抽检频次', value: '周检' }, { label: '预警状态', value: '正常' }], timeline: this.createTimeline(['系统上线', '批次接入', '监管联动', '覆盖提升', '数据治理', '预警完善', '全链溯源'], 2020) }],
				talent: [{ id: 'talent-center', name: '火锅人才服务中心', x: 49, y: 52, suggestion: '门店用工缺口下降，建议扩大技能认证供给。', trend: this.mkTrend([112,86,72,65,58,52,46], [106,80,66,60,54,48,42], [110,94,78,68,60,54,48]), info: [{ label: '服务名称', value: '火锅人才服务中心' }, { label: '人才入库', value: '2.1万人' }, { label: '技能认证', value: '8600人' }, { label: '人岗匹配', value: '3200次' }], timeline: this.createTimeline(['平台上线', '人才入库', '培训认证', '岗位匹配', '技能提升', '就业扩面', '人才梯队'], 2020) }],
				operation: [{ id: 'operation-index', name: '重庆产业运行监测', x: 53, y: 55, suggestion: '产业运行指标稳定，建议关注原料价格波动。', trend: this.mkTrend([108,90,72,61,57,50,47], [102,84,66,56,52,46,42], [112,96,80,64,58,52,46]), info: [{ label: '监测对象', value: '重庆火锅产业' }, { label: '运行指数', value: '86.7' }, { label: '活跃企业', value: '1380家' }, { label: '预警数量', value: '3条' }], timeline: this.createTimeline(['指标建模', '数据接入', '专题分析', '运行监测', '预警体系', '决策支持', '智慧运行'], 2020) }]
			}
		}
	},
	methods: {
		createTimeline(labels, startYear = 2020) {
			const positions = ['top', 'top', 'bottom', 'top', 'bottom', 'top', 'bottom']
			return labels.map((label, i) => ({ year: String(startYear + i), label, position: positions[i] }))
		},
		mkTrend(产量, 销量, 价格) {
			const build = vals => ({
				actual: [8, 58, 110, 160].map((x, i) => `${x},${vals[i]}`).join(' '),
				predict: [160, 214, 270, 312].map((x, i) => `${x},${vals[i + 3]}`).join(' ')
			})
			return { '产量': build(产量), '销量': build(销量), '价格': build(价格) }
		},
		selectPoint(item) {
			this.selectedPointId = item.id
		},
		resetTimelineScroll() {
			this.$nextTick(() => {
				if (this.$refs.timelineWrap) this.$refs.timelineWrap.scrollLeft = 0
			})
		}
	}
}
</script>

<style scoped lang="scss">
.national-map-page {
	position: absolute;
	inset: 0;
	overflow: hidden;
}

.map-wrap {
	width: 100%;
	height: 100%;
	position: relative;
}

.left-menu {
	position: fixed;
	left: 20px;
	top: 102px;
	bottom: 20px;
	width: 270px;
	z-index: 9;
	padding-top: 0;
	box-sizing: border-box;
	background: rgba(10, 125, 190, .25);
	border-radius: 12px;
	box-shadow: inset 0 0 24px rgba(24, 132, 255, .12);
	color: #b8e4f8;
}

.left-menu-item {
	position: relative;
	display: flex;
	align-items: center;
	height: 62px;
	padding: 0 30px;
	color: #b8e4f8;
	font-size: 17px;
	cursor: pointer;
	border-bottom: 1px solid rgba(68, 193, 239, .1);
}

.left-menu-item:hover {
	color: #fff;
	background: rgba(21, 115, 190, .16);
}

.left-menu-item.active {
	color: #fff;
	background: linear-gradient(90deg, rgba(23, 137, 213, .66), rgba(25, 126, 190, .2));
	box-shadow: inset 3px 0 #44c1ef, inset 0 0 20px rgba(24, 132, 255, .18);
}

.left-menu-item i {
	position: absolute;
	right: 30px;
	width: 10px;
	height: 10px;
	border-top: 3px solid currentColor;
	border-right: 3px solid currentColor;
	transform: rotate(45deg);
}

.menu-icon {
	position: relative;
	width: 24px;
	height: 24px;
	margin-right: 18px;
	color: currentColor;
}

.menu-icon.user:before {
	content: '';
	position: absolute;
	left: 6px;
	top: 0;
	width: 12px;
	height: 12px;
	border: 2px solid currentColor;
	border-radius: 50%;
}

.menu-icon.user:after {
	content: '';
	position: absolute;
	left: 1px;
	bottom: 0;
	width: 22px;
	height: 13px;
	border: 2px solid currentColor;
	border-bottom: 0;
	border-radius: 14px 14px 0 0;
}

.menu-icon.mail {
	border: 2px solid currentColor;
	box-sizing: border-box;
}

.menu-icon.mail:before,
.menu-icon.mail:after {
	content: '';
	position: absolute;
	top: 6px;
	width: 15px;
	height: 2px;
	background: currentColor;
}

.menu-icon.mail:before {
	left: 0;
	transform: rotate(36deg);
}

.menu-icon.mail:after {
	right: 0;
	transform: rotate(-36deg);
}

.right-panels {
	position: fixed;
	top: 8vh;
	right: 20px;
	z-index: 120;
	width: 380px;
}

.panel-gap {
	margin-top: 16px;
}

.title {
	width: 20.8vw;
	height: 4vh;
	background-image: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E6%A0%87%E9%A2%98%402x.png');
	background-size: 100% 100%;
}

.title div {
	margin-left: 50px;
	margin-top: -10px;
	font-family: JiangChengXieHei, JiangChengXieHei;
	font-size: 24px;
	font-weight: 900;
	font-style: italic;
	background: linear-gradient(180deg, #FFFFFF 15%, #F7FF57 81%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
}

.info-style {
	box-sizing: border-box;
	width: 380px;
	min-height: 205px;
	padding: 14px 18px;
	background: rgba(10, 125, 190, .25);
	border-radius: 12px;
	box-shadow: inset 0 0 24px rgba(24, 132, 255, .12);
	color: #d8f1ff;
}

.selected-name {
	margin-bottom: 10px;
	padding-bottom: 8px;
	border-bottom: 1px solid rgba(68, 193, 239, .18);
	color: #f7ff57;
	font-size: 16px;
	font-weight: 600;
}

.info-copy p {
	margin: 0 0 8px;
	color: #d8f1ff;
	font-size: 13px;
	line-height: 1.55;
}

.info-copy b {
	color: #8ad4ff;
	font-weight: 500;
}

.timeline-copy {
	color: #d8f1ff;
	font-size: 13px;
	line-height: 1.6;
}

.timeline-wrap {
	width: 100%;
	height: 138px;
	margin-top: 10px;
	overflow-x: auto;
	overflow-y: hidden;
}

.timeline-wrap::-webkit-scrollbar {
	height: 6px;
}

.timeline-wrap::-webkit-scrollbar-track {
	background: rgba(202, 199, 199, .1);
	border-radius: 4px;
}

.timeline-wrap::-webkit-scrollbar-thumb {
	background: #5d70db;
	border-radius: 4px;
}

.timeline-board {
	width: 560px;
	height: 116px;
	padding: 0 12px;
	box-sizing: border-box;
}

.timeline-row,
.timeline-axis {
	display: grid;
	grid-template-columns: repeat(7, 76px);
	width: 532px;
}

.timeline-row {
	height: 38px;
}

.timeline-axis {
	position: relative;
	height: 40px;
}

.timeline-line {
	position: absolute;
	left: 38px;
	right: 38px;
	top: 19px;
	height: 2px;
	background: #0aa7ff;
}

.timeline-year {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 2;
}

.timeline-year b {
	width: 36px;
	height: 36px;
	border-radius: 50%;
	background: #006d9e;
	border: 3px solid #15d6d1;
	line-height: 30px;
	font-size: 11px;
	box-sizing: border-box;
	color: #fff;
	text-align: center;
}

.timeline-cell {
	position: relative;
	display: flex;
	align-items: flex-start;
	justify-content: center;
	color: #b3c8d4;
	font-size: 10px;
	line-height: 1.25;
	text-align: center;
}

.timeline-cell span {
	position: relative;
	display: block;
	width: 70px;
}

.timeline-row-top .timeline-cell span:after {
	content: '';
	position: absolute;
	left: 50%;
	top: 20px;
	width: 1px;
	height: 26px;
	background: rgba(21, 214, 209, .75);
}

.timeline-row-bottom .timeline-cell {
	align-items: flex-end;
}

.timeline-row-bottom .timeline-cell span:before {
	content: '';
	position: absolute;
	left: 50%;
	top: -26px;
	width: 1px;
	height: 26px;
	background: rgba(21, 214, 209, .75);
}

.trend-head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	color: #d8f1ff;
	font-size: 13px;
}

.trend-head select {
	width: 84px;
	height: 28px;
	border: 1px solid rgba(68, 193, 239, .55);
	border-radius: 4px;
	color: #d8f1ff;
	background: rgba(5, 35, 85, .9);
}

.trend-chart {
	position: relative;
	height: 150px;
	margin-top: 10px;
	border-left: 1px solid rgba(68, 193, 239, .35);
	border-bottom: 1px solid rgba(68, 193, 239, .35);
	overflow: hidden;
}

.grid-line {
	height: 29px;
	border-top: 1px dashed rgba(68, 193, 239, .18);
}

.trend-chart svg {
	position: absolute;
	inset: 0;
}

.trend-unit {
	position: absolute;
	top: 4px;
	left: 6px;
	z-index: 3;
	color: #8ad4ff;
	font-size: 12px;
}
</style>
